import { Box } from "theme-ui";

export default function ArrowLeftIcon(props) {
  return (
    <Box
      as="svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.5 9C17.7761 9 18 8.77614 18 8.5C18 8.22386 17.7761 8 17.5 8V9ZM1.5 8C1.22386 8 1 8.22386 1 8.5C1 8.77614 1.22386 9 1.5 9L1.5 8ZM17.5 8L1.5 8L1.5 9L17.5 9V8Z"
        fill="black"
      />
      <path
        d="M9.14645 16.8536C9.34171 17.0488 9.65829 17.0488 9.85355 16.8536C10.0488 16.6583 10.0488 16.3417 9.85355 16.1464L9.14645 16.8536ZM1.5 8.5L1.14645 8.14645L0.792893 8.5L1.14645 8.85355L1.5 8.5ZM9.85355 0.853553C10.0488 0.658291 10.0488 0.341709 9.85355 0.146447C9.65829 -0.0488155 9.34171 -0.0488155 9.14645 0.146447L9.85355 0.853553ZM9.85355 16.1464L1.85355 8.14645L1.14645 8.85355L9.14645 16.8536L9.85355 16.1464ZM1.85355 8.85355L9.85355 0.853553L9.14645 0.146447L1.14645 8.14645L1.85355 8.85355Z"
        fill="black"
      />
    </Box>
  );
}
